import { gray } from '@ant-design/colors';
import { Layout, Tooltip, Typography } from 'antd';
import { FunctionComponent, ReactNode } from 'react';
import { elementSizeAtomFam } from 'packages/lib/common-ui/state';
import { SyncAreaSize } from 'packages/lib/common-ui/sync-area-size/sync-area-size';
import { headerAreaId } from 'packages/at-shell/components/app-shell/app-layout-constants';
import { Breadcrumbs } from 'packages/at-shell/components/app-shell/breadcrumbs';
import { GIT_SHA_SHORT } from 'packages/env';
import {
  appBarActionsId,
  appBarVersionNumId,
} from 'packages/lib/common-ui/app-shell/portals';
import { AppLogo } from 'packages/lib/common-ui/app-shell/app-logo';
import { useParams } from 'react-router-dom';
import useSWR from 'swr';
import { taskZod } from 'packages/lib/api/annotations/contract/task';
import { apiGet } from 'packages/lib/api/annotations/rest';
import { capitalCase, sentenceCase } from 'change-case';
import { useRecoilValue } from 'recoil';
import { multiTasksAtom } from 'packages/at-shell/state/recoil/multitask-workflow';
import { atShellCustomTitleTextAtom } from 'packages/at-shell/state/recoil/ui';
import { sampleGroupAtom } from 'packages/at-shell/state/recoil/task';

const { Header } = Layout;

export const AppHeader: FunctionComponent<
  React.PropsWithChildren<{
    sceneActions: ReactNode;
  }>
> = ({ sceneActions }) => {
  const { task_token } = useParams<{
    task_token: string;
  }>();
  const { data: task } = useSWR(
    !task_token ? undefined : `/tasks/${task_token}`,
    (url: string) => apiGet(url, taskZod.parse)
  );
  const multiTasks = useRecoilValue(multiTasksAtom);
  const customTitleText = useRecoilValue(atShellCustomTitleTextAtom);
  const sampleGroup = useRecoilValue(sampleGroupAtom);

  const annotationState =
    task?.annotationState ?? multiTasks?.[0]?.annotationState;
  const assignee = task?.assignee ?? multiTasks?.[0]?.assignee ?? 'Unassigned';

  return (
    <Header className="layout-header">
      <SyncAreaSize id={headerAreaId} elementSizeAtomFam={elementSizeAtomFam} />
      <div
        style={{
          alignItems: 'center',
          display: 'flex',
        }}
      >
        <AppLogo />
        <Breadcrumbs />
        <div style={{ marginLeft: '1em', paddingRight: '1em', color: 'white' }}>
          {customTitleText}
        </div>
      </div>
      <div style={{ display: 'flex', alignItems: 'center' }}>
        <Tooltip
          title={
            <div>
              <div>
                <b>Batch Name</b>
              </div>
              <div>{sampleGroup?.name}</div>
              <div>
                <b>Assignee</b>
              </div>
              <div>{assignee}</div>
            </div>
          }
        >
          <Typography.Title
            style={{ margin: '0 1rem 0 0', color: 'white' }}
            level={5}
          >
            {annotationState
              ? capitalCase(sentenceCase(annotationState))
              : task
              ? 'Viewer'
              : ''}
          </Typography.Title>
        </Tooltip>
        <Tooltip title="App Version">
          <span
            id={appBarVersionNumId}
            style={{
              color: gray[2],
            }}
          />
        </Tooltip>
        <Tooltip title="Latest Release Commit Hash">
          <span
            style={{
              marginRight: '0.75rem',
              color: gray[2],
            }}
          >
            Version: {GIT_SHA_SHORT}
          </span>
        </Tooltip>
      </div>
      <div style={{ display: 'flex', alignItems: 'center' }}>
        <span id={appBarActionsId} />
        {sceneActions}
      </div>
    </Header>
  );
};
